module.exports = __webpack_public_path__ + "static/media/ib_fulltime_teachers_banner.40100628.jpg";